module.exports = __webpack_public_path__ + "img/shankertational-hawk.91c810a2.jpg";